import React, { useState } from 'react';
import { useDrop } from 'react-dnd';
import { X } from 'lucide-react';

const LearnerRow = ({ groupId, learner, onUpdateName, onAddModule, onRemoveModule }) => {
  const [dragOver, setDragOver] = useState(false);

  const [{ isOver }, drop] = useDrop(() => ({
    accept: 'module',
    drop: (item) => {
      onAddModule(groupId, learner.id, item);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  }));

  React.useEffect(() => {
    setDragOver(isOver);
  }, [isOver]);

  const hasModules = learner.modules.length > 0;

  return (
    <div
      ref={drop}
      className={`learner-row ${
        hasModules ? 'has-modules' : ''
      } ${
        dragOver ? 'drag-over' : ''
      }`}
      data-testid={`learner-row-${learner.id}`}
    >
      <input
        type="text"
        placeholder="Nom / poste *"
        value={learner.name}
        onChange={(e) => onUpdateName(groupId, learner.id, e.target.value)}
        className={`form-input flex-shrink-0 w-48 mr-4 ${
          hasModules && !learner.name.trim() ? 'required' : ''
        }`}
        data-testid={`learner-name-${learner.id}`}
      />
      
      <div className="flex flex-wrap gap-2 flex-1">
        {learner.modules.map(module => {
          const moduleClass = `module-${module.module_id}`;
          return (
            <div
              key={module.module_id}
              className={`${moduleClass} px-3 py-1 rounded-md text-sm font-medium flex items-center gap-2 group relative`}
              data-testid={`assigned-module-${module.module_id}`}
            >
              {module.module_id}
              <button
                onClick={() => onRemoveModule(groupId, learner.id, module.module_id)}
                className="text-white hover:text-red-200 transition-colors opacity-0 group-hover:opacity-100"
                data-testid={`remove-module-${module.module_id}`}
              >
                <X size={14} />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LearnerRow;